import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Link } from '../Link/Link';
import './ArticlesItem.scss';

export const ArticlesItem = (props) => {
  const { title, url, contentIntroText } = props;

  return (
    <div className="article-item">
      <Link href={url} noUnderline variant="secondary" extendClass="article-item__title">
        {title}
      </Link>
      <p className="article-item__description" data-testid="description">
        {parse(contentIntroText)}
      </p>
    </div>
  );
};

ArticlesItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  contentIntroText: PropTypes.string,
};
